import { render, staticRenderFns } from "./GroupSubgroupTransfer.vue?vue&type=template&id=23e98224&"
import script from "./GroupSubgroupTransfer.vue?vue&type=script&lang=js&"
export * from "./GroupSubgroupTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports